import { Image, Text, Group } from "react-konva";
import { useState, useEffect } from "react";

export default function Seat ({x, y, number, onSelect, isSelected, rotation=0, width, height, row, column, id}) {
  const [seatImage, setSeatImage] = useState(null)

  useEffect(() => {
    const img = new window.Image();
    img.src = '/img/seat.svg'
    img.onload = () => setSeatImage(img);
  }, []);
  
  return (<>
    <Group x={x} y={y} width={width} height={height} onClick={() => onSelect(number)}>
      <Image width={width} height={height} offsetX={width/2} offsetY={height/2} image={seatImage} rotation={rotation} opacity={isSelected ? 1 : 0.5}/>
      <Text x={-5} y={-6} text={id} fontSize={10} fill="black"/>
    </Group></>
  );
};